export const UI_FEATURE_FLAGS = {
  USE_NEW_BASE_FORM: 'UseNewBaseForm',
  ENABLE_FORM_POLICY_ACCESS_CONTROL: 'EnableFormPolicyAccessControl',
  ENABLE_FORM_SECTION_POLICY: 'EnableFormSectionPolicy',
  ENABLE_FORM_ACTION_POLICY: 'EnableFormActionPolicy',
  ENABLE_FORM_LIST_POLICY: 'EnableFormListPolicy',
} as const;

export type UiFeatureFlagKey = (typeof UI_FEATURE_FLAGS)[keyof typeof UI_FEATURE_FLAGS];
